<script>
  import productComponent from './product/product.vue';

  export default {
    data() {
      return {
        isHidden: true,
        isPrintedLoading: false,
      };
    },
    props: [
      'shipment',
    ],
    computed: {
      getPersonalInfo() {
        if (this.shipment.fbm_label) return false;

        const { shipment } = this;

        return `${shipment.first_name} ${shipment.last_name}, (tel: ${shipment.phone})`;
      },
      getAddress() {
        if (typeof this.shipment === 'undefined' || this.shipment.fbm_label) return false;

        const { shipment } = this;

        const address = [
          [shipment.first_name, shipment.last_name],
          [shipment.address],
          [shipment.city + ',', shipment.state + ',', shipment.country, shipment.postcode]
        ];

        return address.map((item) => item.join(' ')).join("\r\n");
      },
      getTrackingLink() {
        if (typeof this.shipment === 'undefined') return false;

        return `http://parcelsapp.com/tracking/${this.shipment.tracking_code}`;
      },
      app_section() {
        return this.$store.getters.get_app_section;
      },
    },
    components: {
      product_component: productComponent,
    },
    filters: {
      setLabelName(name) {
        if (!name) return name;
        let sliced = name.slice(0, 15);
        if (name !== sliced) sliced += '...';
        return sliced;
      },
    },
  };
</script>
<template src="./shipment.pug" lang="pug"></template>
